import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocTypeCompInfoRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const policyHolderId = control.get('policyHolderId')!.value;
	const foreignCustomerId = control.get('foreignCustomerId')!.value;

	return  documentCategory !== 'EGD02'  &&  documentType === 'EGD031' && (!foreignCustomerId && !policyHolderId) ?
		{ checkDocTypeCompInfoFlag: true } : null;

};
